// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import axios from 'axios'
import App from './App'
// 引入vuex 变量名是固定死的
import router from './router'
import $ from 'jquery'
import moment from 'moment'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)
Vue.config.productionTip = false
Vue.prototype.$moment = 'moment'

/* eslint-disable no-new */
new Vue({
  el: '#app',
  axios,
  router,
  components: { App },
  template: '<App/>'
})
// 全局过滤器-时间戳转时间
Vue.filter('mTime', (dataStr, pattern = 'YYYY-MM-DD') =>{
  return moment(dataStr).format(pattern)
})


// WEBPACK FOOTER //
// ./src/main.js